import { render, staticRenderFns } from "./SurveyManage.vue?vue&type=template&id=13f92f48&scoped=true"
import script from "./SurveyManage.vue?vue&type=script&lang=js"
export * from "./SurveyManage.vue?vue&type=script&lang=js"
import style0 from "./SurveyManage.vue?vue&type=style&index=0&id=13f92f48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f92f48",
  null
  
)

export default component.exports